import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  tracesSampleRate: 0,
  // A promise rejected with literally nothing, with no stack frames, comes from code outside our bundle
  // (browser extensions, Safari/Edge injected scripts). Kept narrow so real non-Error rejections still report.
  ignoreErrors: [
    /^Non-Error promise rejection captured with value: undefined$/,
    // The browser's generic "fetch could not complete" error: the page navigated away or went offline while a
    // request was in flight. Turbo re-throws it from FetchRequest#perform with nothing upstream to catch it, so it
    // surfaces as an unhandled rejection. Safari says "Load failed", Chrome "Failed to fetch", Firefox the long one.
    /^Load failed$/,
    /^Failed to fetch$/,
    /^NetworkError when attempting to fetch resource\.$/,
  ],
  // Drop events whose frames originate from a browser extension.
  denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//, /^safari-(web-)?extension:\/\//],
});


export class SentryTest {
  static setup() {
    const sentryTest = document.querySelector('[href="/sentry_tests/new"]');
    if (sentryTest) {
      sentryTest.addEventListener('click', function () {
        setTimeout(() => {
          throw new Error('Sentry Test Error (JS)');
        });
      });
    }
  }
}
